import { CompanyEnum } from "../enums/Company/CompanyEnum";

function GenerateDegradeMaskPages(theme: any, hslColor: any, companyId?: number): string {
    const l10 = theme?.l10 ?? hslColor?.l;
    const l40 = theme?.l40 ?? hslColor?.l;

if (companyId === CompanyEnum.BEVI) {
    return `linear-gradient(rgb(17, 18, 34), rgb(5, 20, 96))`;
}


    return `linear-gradient(rgb(17, 18, 34), rgb(5, 20, 96))`;
}

export default GenerateDegradeMaskPages;